import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Subject, takeUntil } from 'rxjs';
import { manageStorageService } from '@core/services/manage-storage/manage-storage.service';
import { ApiService } from '@core/services/api';

@Injectable({
  providedIn: 'root',
})
export class ManageTickerService {

  // -----------------------------------------------------------------------------------------------------
// @ Decorators
// -----------------------------------------------------------------------------------------------------

// -----------------------------------------------------------------------------------------------------
/** constructor  */
// -----------------------------------------------------------------------------------------------------
constructor( private _api: ApiService) {
  
}
// -----------------------------------------------------------------------------------------------------
// @ Public declaration vars
// -----------------------------------------------------------------------------------------------------

// -----------------------------------------------------------------------------------------------------
// @ Private declaration vars
// -----------------------------------------------------------------------------------------------------

// -----------------------------------------------------------------------------------------------------
// @ Lifecycle hooks
// -----------------------------------------------------------------------------------------------------

// -----------------------------------------------------------------------------------------------------
// @ Private methods
// -----------------------------------------------------------------------------------------------------

// -----------------------------------------------------------------------------------------------------
// @ Public methods
// -----------------------------------------------------------------------------------------------------

  getTickerDetail() {
    return new Promise((rslvAuth, rjctAuth):any => {
      this._api
        .gEt('comunes/v1/consultaTicker')
        .subscribe(
          {
            next: (rpsnsTicker: any) => {
              rslvAuth(rpsnsTicker.body?.data)
            },
            error: (eRR) => rjctAuth(eRR)
          }
        )
    });

  }
}